import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/logHistory'

export const logHistoryService = {
    get,
    getPagedList,
    search,
    getModels,
    listAllModelsToDoTaks,
    searchDashboard
};

function searchDashboard(data) {
    return utilHelper.doRequest(`${relativeUrl}/searchDashboard`, 'POST', data)
}

function get(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

function getPagedList(offset, max) {
    return utilHelper.doRequest(`${relativeUrl}?max=${max}&offset=${offset}`, 'GET')
}

function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert:false })
}

function getModels() {
    return utilHelper.doRequest(`${relativeUrl}/listAllModels`, 'GET')
}

function listAllModelsToDoTaks() {
    return utilHelper.doRequest(`${relativeUrl}/listAllModelsToDoTaks`, 'GET')
}
